import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    grids: [] as any,
  },

  getters: {
    grids: (state) => state.grids,
    firstGrids: (state) => {
      const firstGrids = [] as any;
      state.grids.forEach((grid: any, index: number) => {
        const previousGrid = state.grids[index - 1];
        const nextGrid = state.grids[index + 1];
        if (index === 0) { // first element is always first grid
          firstGrids.push(grid);
        } else if (previousGrid // when previous element is not directly previous and is not an nba component
          && grid.dataAnalyticsContentMilestone !== previousGrid.dataAnalyticsContentMilestone + 1 && grid.dataAnalyticsContentMilestone !== -1) {
          firstGrids.push(grid);
        } else if (index === 0 // when next element is directly next or is an nba component
          && nextGrid && (grid.dataAnalyticsContentMilestone === nextGrid.dataAnalyticsContentMilestone - 1 || nextGrid.dataAnalyticsContentMilestone === -1)) {
          firstGrids.push(grid);
        }
        firstGrids[firstGrids.length - 1].tabs.push(grid);
      });
      return firstGrids;
    },
  },

  mutations: {
    addGrid (state, grid) {
      state.grids.push(grid);
    },
  },
});
